import Axios, { AxiosResponse } from 'axios';
import * as XmlParser from 'xml-js';
import { BASE_URL } from '../env';
import 'core-js/features/string/starts-with';
import 'core-js/features/string/ends-with';

export function getBaseUrl(): string {
    // In case of running on localhost, replace relative api address with the test url.

    if (window.location.host === 'localhost:3000') {
        return BASE_URL;
    }
    // End of debug code.

    const server = window.location.protocol + '//' + window.location.host;
    let path = window.location.pathname;
    if (!path) return server;

    if (path.startsWith('/')) {
        path = path.substring(1);
    }
    if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
    }
    if (path.toLowerCase().endsWith('/welcome')) {
        path = path.substring(0, path.length - 8);
    }
    if (path.toLowerCase() === 'welcome') {
        path = '';
    }
    if (path) {
        return server + '/' + path;
    }
    return server;
}

export function callWsGet<TResult extends object>(
    methodName: string,
    successCallback: (result: TResult) => void,
    errorCallback: (error: any) => void
) {
    const address = getBaseUrl() + '/eWayWS.asmx/' + methodName;
    Axios.get(address)
        .then((response: AxiosResponse) => {
            if (response.status === 200) {
                const data: TResult = JSON.parse(XmlParser.xml2json(response.data, { compact: true }));
                successCallback(data);
            } else {
                console.error('eWay WS get response error: ' + JSON.stringify(response));
                errorCallback(response);
            }
        })
        .catch((error) => {
            console.error('eWay WS get request failed: ' + JSON.stringify(error));
            errorCallback(error);
        });
}
